// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    chain,
    DispatchUpdateVariantSelection,
    SetProductInfo,
} from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/UpdateVariantSelection";
import {
    addToChainBefore,
    executeAwaitableHandlerChain,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import loadProduct from "@insite/client-framework/Store/Data/Products/Handlers/LoadProduct";
import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import { ConfigurationType } from "@insite/client-framework/Services/ProductServiceV2";
import logger from "@insite/client-framework/Logger";

const DispatchLoadProductConfiguration: typeof SetProductInfo = async props => {
    const product = getProductState(props.getState(), props.selectedProductId).value;
    if (!product || product.properties.configurationType !== ConfigurationType.Standard) {
        return;
    }

    await executeAwaitableHandlerChain(
        loadProduct,
        {
            id: product.id,
            unitOfMeasure: props.productInfo?.unitOfMeasure,
            expand: [
                "properties",
                "detail",
                "specifications",
                "content",
                "images",
                "documents",
                "attributes",
                "variantTraits",
            ],
        },
        props,
    );
};

// XNG-Changes
// https://xngage.atlassian.net/browse/SAINC-1543
// TODO: Temporary solutin, Opti fix it in a new releases
// Remove after next upgrade
const SetProductInfoSafe: typeof SetProductInfo = props => {
    try {
        SetProductInfo(props);
    } catch (error) {
        logger.error("SetProductInfo failed:", error);
        return false;
    }
};

replaceInChain(chain, SetProductInfo, SetProductInfoSafe);
addToChainBefore(chain, DispatchUpdateVariantSelection, DispatchLoadProductConfiguration);
